import AppHeader from "@/components/AppHeader";
import { cn } from "@/lib/utils";

interface PageLayoutProps {
  children: React.ReactNode;
  /** Override the inner <main> classes — use for form pages that need max-w-3xl */
  mainClassName?: string;
  /** Stretch layout to full screen height — use for pages with fill-height grids */
  fullHeight?: boolean;
  /** Expand content to full viewport width, breaking out of the max-width container */
  isExpanded?: boolean;
}

const PageLayout = ({ children, mainClassName, fullHeight, isExpanded }: PageLayoutProps) => {
  const wrapperClass = fullHeight ? "h-screen flex flex-col bg-background" : "min-h-screen bg-background";
  const mainClass = cn(
    "px-6 py-8 w-full",
    fullHeight && "flex-1 flex flex-col overflow-hidden",
    !isExpanded && "container-lg",
  );

  return (
    <div className={wrapperClass}>
      <AppHeader />
      <main className={cn(mainClass, mainClassName)}>
        {children}
      </main>
    </div>
  );
};

export default PageLayout;
